<template>
    <div>
        <vue-headful :title="'[Users - '+userCount+'] - AMOS365'" />

        <h4 class="page-header">
            Users ({{ userCount }})

            <router-link to="/users/create" class="btn btn-sm btn-info" v-if="canManageUsers">
                <i class="fas fa-plus-square"></i> Create
            </router-link>
        </h4>

        <div class="card">
            <div class="card-body">
                <v-server-table ref="usersTable" url="/users" :columns="columns" :options="options">

                    <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

                    </div>

                    <div slot="afterFilter" class="ml-2">
                        <div class="d-inline-block">
                            <button type="button" class="btn btn-sm btn-success" v-on:click="exportTable()" :disabled="exportingTable">
                                <template v-if="!exportingTable"><i class="fa fa-file-excel"></i> Export</template>
                                <template v-else><i class="fa fa-spinner fa-spin"></i> Exporting</template>
                            </button>
                        </div>
                        <div class="d-inline-block ml-2">
                            <b-form-checkbox v-model="hide_inactive" :value="1" :unchecked-value="0" plain>Hide Inactive</b-form-checkbox>
                        </div>
                    </div>

                    <template slot="id" slot-scope="props">

                    </template>

                    <template slot="last_name" slot-scope="props">
                        <router-link :to="`/users/view/${props.row.id}`">{{ props.row.last_name }}, {{ props.row.first_name }}</router-link>
                    </template>

                    <template slot="last_login_at" slot-scope="props">
                        <span v-if="props.row.last_login_at">{{ props.row.last_login_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</span>
                    </template>

                    <template slot="is_active" slot-scope="props">
                        <label class="badge badge-success" v-if="props.row.is_active == 1">Active</label>
                        <label class="badge badge-warning" v-else>Inactive</label>
                    </template>
                </v-server-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                userCount: null,
                exportingTable: false,
                hide_inactive: 1,
                userTimezone: this.$root.timezone,
                columns: ['last_name', 'email', 'last_login_at', 'is_active'],
                options: {
                    headings: {
                        last_name: 'Name',
                        email: 'Email',
                        last_login_at: 'Last Login',
                        is_active: 'Active',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'users.last_name',
                    },
                    texts:{
                        filterPlaceholder:"Search Users",
                    },
                    responseAdapter: (response) => {
                        //Set the count
                        this.userCount = response.data.count;

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Append
                        data.hide_inactive = this.hide_inactive;

                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },
            }
        },

        watch: {
            hide_inactive(newVal, oldVal){
                //Refresh
                this.$refs.usersTable.refresh();
            }
        },

        computed: {

            canManageUsers(){
                //Check Permissions
                return this.$root.hasPermission("users.manage");
            },
        },

        methods: {

        },

        mounted() {
            //Focus on the SEarch Input
            this.$refs.usersTable.$refs.genericFilter.focus();
        }
    }
</script>
